import api from "../..";
import { PutReportStatusParams } from "./types";

export const putReportStatus = async ({ id, type, body }: PutReportStatusParams): Promise<boolean> => {

  return await api.put(`/reports/${type}-reports/${id}/update-status/`, body)
  .then(() => true)
  .catch(() => false);
};